import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hmt-assign-notify-confirmation-dialog',
  templateUrl: './assign-notify-confirmation-dialog.component.html',
  styleUrls: ['./assign-notify-confirmation-dialog.component.scss'],
  standalone: false
})
export class AssignNotifyConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AssignNotifyConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message?: string }
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}

